export const isUndefined = (required, value) => required && (value == null || value === '' || value === false)